<div class="profile-progress-wrapper">
  <div class="outer-circle">
    <div class="inner-circle">
      @if (userData?.avtar) {
        <img src="{{userData?.avtar?.cdn_path}}" alt="user img" />
      }
      @if (userData?.avtar === null && initials) {
        <div class="initials">
          {{initials}}
        </div>
      }
      @if (userData?.avtar === null && !initials) {
        <mat-icon class="person-icon">person</mat-icon>
      }
    </div>
    <div class="progress-bar">
      <svg width="134px" height="134px">
        <defs>
          <linearGradient id="linearGradient">
            <stop offset="0%" stop-color="#2A7AAC"/>
            <stop offset="100%" stop-color="#2A7AAC"/>
          </linearGradient>
        </defs>
        <circle cx="67px" cy="67px" r="60"
          [attr.stroke-dasharray]="dashArray"
          [attr.stroke-dashoffset]="dashOffset"
        [ngStyle]="{'animation': animationStyle}"></circle>
      </svg>
    </div>
  </div>
</div>